import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("404")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "view-not-found__text" }, [
  /*#__PURE__*/_createTextVNode(" There’s no page you are looking for. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" But there’s still hope! ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to home ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_page_two_columns = _resolveComponent("page-two-columns")!

  return (_openBlock(), _createBlock(_component_page_two_columns, _mergeProps({
    class: "view-not-found",
    sticky: "left"
  }, { division: _ctx.division }), {
    left: _withCtx(() => [
      _createVNode(_component_page_header, { "reserve-vertical-space": false }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_card, null, {
        footer: _withCtx(() => [
          _createVNode(_component_base_button, {
            class: "view-not-found__back-button",
            size: "small",
            to: { name: 'home' }
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}